<script setup>
    const props = defineProps({
        title: String,
        body: String,
        url: {
            type: String,
            default: undefined
        }
    });

    function onShare(t) {
        const url = (props.url || location.href).replace('&', '%26');
        const title = props.title;
        const body = `${props.body || 'I thought you might be interested in this: '} ${url}`;

        if (t === 'fb') {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
        } else if (t === 'x') {
            window.open(`https://twitter.com/intent/tweet?text=${title}&url=${url}`);
        } else if (t === 'em') {
            window.open(`mailto:?subject=${title}&body=${body}`);
        }
    }
</script>

<template>
    <div class="flex items-center justify-center mt-16">
        <n-button type="success" size="large" circle ghost @click="onShare('fb')">
            <n-icon size="23">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512">
                    <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48c27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" fill="currentColor"></path>
                </svg>
            </n-icon>
        </n-button>
        <n-divider class="!mx-4" vertical dashed />
        <n-button type="success" size="large" circle ghost @click="onShare('x')">
            <n-icon size="18">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                </svg>
            </n-icon>
        </n-button>
        <n-divider class="!mx-4" vertical dashed />
        <n-button type="success" size="large" circle ghost @click="onShare('em')">
            <n-icon size="25">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
                    <path d="M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-2.2 2L16 14.78L6.2 8zM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24z" fill="currentColor"></path>
                </svg>
            </n-icon>
        </n-button>
    </div>
</template>
